import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "property-form-row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ontos_computed_input = _resolveComponent("ontos-computed-input")!
  const _component_ontos_alias_fields = _resolveComponent("ontos-alias-fields")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ontos_computed_input, {
      label: _ctx.$tt('relationship-name'),
      class: "required unique",
      "hide-details": "auto",
      value: _ctx.model.name,
      manual: _ctx.manualName,
      "onInput:manual": _cache[0] || (_cache[0] = ($event: any) => (_ctx.manualName = $event)),
      source: _ctx.nameSource,
      compute: _ctx.computeName,
      "error-messages": _ctx.errors.name,
      onInput: _cache[1] || (_cache[1] = ($event: any) => {_ctx.model.name = $event; _ctx.check('name')}),
      onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.check('name')))
    }, null, 8, ["label", "value", "manual", "source", "compute", "error-messages"]),
    _createVNode(_component_ontos_alias_fields, {
      alias: _ctx.model.alias,
      source: _ctx.model.name,
      fixed: !!_ctx.currentAlias,
      manual: _ctx.manualAlias,
      "onUpdate:manual": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.manualAlias) = $event)),
      "error-message": _ctx.errors.alias,
      onInput: _cache[4] || (_cache[4] = ($event: any) => {_ctx.model.alias = $event; _ctx.check('alias')}),
      onBlur: _cache[5] || (_cache[5] = ($event: any) => (_ctx.check('alias')))
    }, null, 8, ["alias", "source", "fixed", "manual", "error-message"])
  ]))
}